import { useThemeStore } from '@shared/store';
import { commonApi } from '../../apis';

// 初始化小站背景色配置
export const initStationBgColor = async () => {
  try {
    const { ret, retdata = {} } = await commonApi.getStationBgColor<any, any>({});

    ret === 0 && useThemeStore().setStationBgColor(retdata.customizeBgcolor || {});
  } catch (error) {
    console.log('初始化小站背景色配置错误：', error);
  }
};
